module.exports = "/_next/static/images/threads-filled-icon-c0bae5cbe2b087a69eefc249e64dd82e.svg";